// AboutRulePage.jsx
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const sectionStyle = (backgroundColor) => ({
  backgroundColor,
  borderRadius: "12px",
  padding: "16px",
  marginBottom: "32px",
  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
});

const headingStyle = (color) => ({
  fontSize: "20px",
  fontWeight: "700",
  color,
  marginBottom: "8px",
});

const subListStyle = { paddingLeft: "20px", marginTop: "4px" };

export default function RulePage() {
  const { hash } = useLocation();

  // BBS から /rule#bbs で来たら BBS のルールまで送る
  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (el) el.scrollIntoView({ block: "start" });
  }, [hash]);

  return (
    <div
      style={{
        background: "linear-gradient(180deg, #ecfdf5 0%, #f0fdf4 100%)",
        padding: "16px 8px",
      }}
    >
      <header
        style={{
          textAlign: "center",
          marginBottom: "32px",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "800",
            color: "#047857",
            letterSpacing: "1px",
            marginBottom: "8px",
          }}
        >
          西鉄バスWatch!
        </h1>
        <p style={{ color: "#065f46", fontWeight: "500" }}>
          コミュニティ利用ガイド
        </p>
      </header>

      {/* 当サイトについて */}
      <section style={sectionStyle("#d1fae5")}>
        <h2 style={headingStyle("#047857")}>当サイトについて</h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.6", color: "#065f46" }}>
          <li>投稿データは誰でも閲覧可能ですが、情報を投稿する場合はユーザ登録が必要です。</li>
          <li>投稿内容は有志による情報提供に基づくため、正確性を保証するものではありません。</li>
          <li>利用者同士が気持ちよく情報を共有できるよう、マナーを守って投稿してください。</li>
        </ul>
      </section>

      {/* 目撃情報の投稿ルール */}
      <section style={sectionStyle("#fef2f2")}>
        <h2 style={headingStyle("#b91c1c")}>目撃情報の投稿ルール</h2>
        <p style={{ fontWeight: "600", marginBottom: "8px" }}>
          投稿ルールに従わない場合、アカウント制限などの対応が行われることがあります。違反投稿を見かけたら、通報機能でお知らせください。
        </p>
        <ol style={{ paddingLeft: "20px", lineHeight: "1.6", color: "#991b1b" }}>
          <li>
            <strong>事実に基づく投稿をお願いします。</strong>
            <ul style={subListStyle}>
              <li>西鉄バスナビアプリのついせき機能で確認した情報、もしくは実際に目撃した情報を記載してください。</li>
              <li>投稿は、始発バス停の発車時刻を過ぎてからにしてください。発車時刻より前は投稿できません（バスナビの「車庫→始発地」表示や、営業所や折返所等を出るところを目撃した場合も同じです）。</li>
              <li>臨時バスなどで始発の時刻が分からないときは、目撃したバス停での時刻で構いません。始発地が分からないときは「コメント欄記入」を選び、その旨をコメントに書いてください。</li>
              <li>ほかの方が SNS 等で発信した目撃を投稿するときは、コメントに出典（例：X で確認）を書いてください。</li>
              <li>推測や虚偽の情報は禁止です。</li>
            </ul>
          </li>
          <li>
            <strong>コメント（行先番号など）は任意です。</strong>
            <ul style={subListStyle}>
              <li>行先番号を書くときは、始発バス停を発車した時点の番号を書いてください。</li>
              <li>途中で番号が変わる便は「46L→46→68-1」のように、始発時点の番号から順に並べてください。</li>
            </ul>
          </li>
          <li>
            <strong>個人情報や業務情報の記載は禁止です。</strong>
            <ul style={subListStyle}>
              <li>運転士氏名等の個人情報や、乗番情報（例：脇山線1A、10、11T等）や系統コード等の業務情報は、記載しないでください。</li>
            </ul>
          </li>
          <li>
            <strong>投稿内容は節度ある表現でお願いします。</strong>
            <ul style={subListStyle}>
              <li>誹謗中傷や他者が不快になる表現は禁止です。</li>
            </ul>
          </li>
        </ol>
      </section>

      {/* BBS のルール */}
      <section id="bbs" style={{ ...sectionStyle("#fff7ed"), scrollMarginTop: "16px" }}>
        <h2 style={headingStyle("#c2410c")}>情報提供BBSのルール</h2>
        <p style={{ fontWeight: "600", marginBottom: "8px" }}>
          次の点をお守りください。
        </p>
        <ol style={{ paddingLeft: "20px", lineHeight: "1.6", color: "#9a3412" }}>
          <li>
            <strong>スレッドは運営管理者が立てます。</strong>
            <ul style={subListStyle}>
              <li>新しい話題や機能の要望は「要望全般」スレッドへお願いします。</li>
            </ul>
          </li>
          <li>
            <strong>情報には確認した方法と日付を添えてください。</strong>
            <ul style={subListStyle}>
              <li>バスナビ・目視・現地など、どう確認したかを書いてください。</li>
              <li>Xなどほかのサイトで知った情報は、出典を書いてください。</li>
              <li>新車・転属は、稼働（バスナビの反応や目撃）が確認できてから反映します。</li>
              <li>出典のない伝聞や推測だけの情報は、反映を見送ることがあります。</li>
            </ul>
          </li>
          <li>
            <strong>廃車情報は、1台ごとに次のいずれかを確認してから投稿してください。</strong>
            <ul style={subListStyle}>
              <li>事業者等による公式発表</li>
              <li>ナンバープレートの撤去</li>
              <li>方向幕・LED行先表示器の撤去</li>
              <li>運賃箱・バスロケ機器などの撤去</li>
            </ul>
            <p style={{ margin: "4px 0 0" }}>
              確認した日と方法も添えてください。代替車の稼働や減車だけでは廃車として扱いません（離脱の可能性として書くことは構いません）。
            </p>
          </li>
          <li>
            <strong>ほかの方の誤投稿は、BBSではなく通報でお知らせください。</strong>
            <ul style={subListStyle}>
              <li>目撃情報の詳細画面にある「通報」から送れます。BBSで個別の投稿を取り上げることはお控えください。</li>
            </ul>
          </li>
          <li>
            <strong>公表されていない業務情報は書かないでください。</strong>
            <ul style={subListStyle}>
              <li>乗番・系統コード・運転士の情報のほか、車両の改造や配置の予定など、事業者や関連協議会等が公表していない情報も含みます。</li>
              <li>
                運用のつながり（どの車がどの便を続けて走ったか）を話題にしたり、運用表にまとめたりすることは構いません。ただし実在する乗番・運用番号は使わず、独自の番号や時刻・行先で表してください。当サイトの運用解析も、同じ考え方で独自の記号を使用しています。
              </li>
            </ul>
          </li>
        </ol>
      </section>

      {/* 戻るリンク */}
      <section style={{ textAlign: "center" }}>
        <Link
          to="/"
          style={{
            display: "inline-block",
            backgroundColor: "#fff",
            color: "#047857",
            padding: "8px 16px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "600",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e5ffe5")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
        >
          トップページへ戻る
        </Link>
      </section>
    </div>
  );
}
